// extracted by mini-css-extract-plugin
export default {"pageWrapper":"style_pageWrapper__Q4KfI","content":"style_content__6MZDe"};